export class FeedApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * @returns FeedItem
     * @throws ApiError
     */
    get() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/feed',
        });
    }
}
